import React, { useEffect, useState } from "react";
import SearchSelectBox from "../SearchSelectBox";
import { AgeGroup, ageGroupNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getStaffDetails } from "../../api/dataCapture";
import { setStaffDetails } from "../../redux/reducers/dataCaptures";

const StaffSelect = (props:any) => {
    const { value, manageSelect, label, isError, errorMessage, isReadOnly } = props;
    const staffList = useSelector((state:any) => state.dataCaptures.staffDetails);
    const currentClub = useSelector((state:any) => state.clubDetails);
    const [isFetching, setIsFetching] = useState(false);
    const [t] = useTranslation();
    const [options, setOptions] = useState([]);
    const dispatch = useDispatch();

    const updateOptions = (list:any) => {
        const updatedOptions = list.map((item:any) => {return {id: item?.id, name: item?.kanjiName}});
        const tempOptions:any = [{ id: -1, name: t('DC_NONE') }, ...updatedOptions];
        setOptions(tempOptions);
    }
    const fetchStaffList = async () => {
        setIsFetching(true);
        const response = await getStaffDetails({ clubId: currentClub?.id, isPast: false });
        dispatch(setStaffDetails(response));
        setIsFetching(false);
        updateOptions(response);
    }
    useEffect(() => {
        !isFetching && currentClub && currentClub?.id && (staffList == undefined || staffList?.length == 0) && fetchStaffList();
        updateOptions(staffList);
    }, [value]);

    return (
        <>
            <SearchSelectBox
            options={options}
            selectedValue={value}
            manageSelect={(e:any) => {manageSelect(e.value)}}
            label={label}
            isError={isError}
            errorMessage={errorMessage}
            disabled={isReadOnly}
            />
        </>
    );
}

export default StaffSelect;